import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class DpCatalogo<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
 * @description Get distributor by token
 *
 * @tags DpCatalogo
 * @name DpCatalogoGetDistributorByToken
 * @summary Get distributor by token
 * @request GET:/store/{storeId}/dpcatalogo/distributor/byToken/{token}
 * @secure
 * @response `200` `{
    lastName?: string,
    logonId?: string,
    name?: string,
    email?: string,

}` The requested completed successfully.
 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	dpCatalogoGetDistributorByToken = (
		storeId: string,
		token: string,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['dpCatalogoGetDistributorByToken'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/dpcatalogo/distributor/byToken/${token}`,
				params: _params,
				methodName: 'dpCatalogoGetDistributorByToken',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				lastName?: string;
				logonId?: string;
				name?: string;
				email?: string;
			},
			void
		>({
			path: `/store/${storeId}/dpcatalogo/distributor/byToken/${token}`,
			method: 'GET',
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
 * @description Send order
 *
 * @tags DpCatalogo
 * @name DpCatalogoSendOrder
 * @summary Send order
 * @request POST:/store/{storeId}/dpcatalogo/orders/{orderId}/send
 * @secure
 * @response `200` `{
    success: boolean,

}` The requested completed successfully.
 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	dpCatalogoSendOrder = (
		storeId: string,
		orderId: string,
		data: {
			token: string;
			clientFullName: string;
			clientEmail: string;
			clientPhone: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['dpCatalogoSendOrder'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/dpcatalogo/orders/${orderId}/send`,
				params: _params,
				body: data,
				methodName: 'dpCatalogoSendOrder',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				success: boolean;
			},
			void
		>({
			path: `/store/${storeId}/dpcatalogo/orders/${orderId}/send`,
			method: 'POST',
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
